import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import CrudWithSteps from '../../../../../components/CrudWithSteps/CrudWithSteps';
import AssignmentLateRoundedIcon from '../../../../../components/Icons/AssignmentLateRoundedIcon';
import AssignmentTurnedInRoundedIcon from '../../../../../components/Icons/AssignmentTurnedInRoundedIcon';
import CloudIcon from '../../../../../components/Icons/CloudIcon';
import DescriptionRoundedIcon from '../../../../../components/Icons/DescriptionRoundedIcon';
import { UnauthorizedScreen } from '../../../../../components/UnauthorizedScreen';
import {
  allContratoAssessorEditEtapas,
  CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
  CONTRATO_EDIT_ETAPA_ARQUIVOS,
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_VALIDACAO,
} from '../../../../../library/ContratoEditEtapas';
import {
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
} from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoAditivoNovoRoute,
  contratoDistratoEditRoute,
  contratoDistratoNovoRoute,
  contratoEditRoute,
} from '../../../../../library/Routes';
import {
  loadContratoAnaliseOperacional,
  loadMacrosPorTemplate,
} from '../../../../../store/modules/ContratosActions';
import {
  changeContratoAssessorEditingValue,
  clearContratoAssessorEditing,
  loadContratoAssessor,
  loadContratoValidacao,
  loadHistoricoContratoAssessorAnaliseOperacional,
  loadContratoAssessorArquivos,
} from '../../../../../store/modules/ContratosAssessoresActions';
import { loadEmpresaByCnpj } from '../../../../../store/modules/EmpresasActions';
import { getContratoTipoByRouteParams } from '../../../../../utils/ContratoUtils';
import AnaliseOperacional from './AnaliseOperacional';
import Arquivos from './Arquivos';
import styles from './ContratoAssessorEdit.scss';
import DadosAssessor from './DadosAssessor';
import DadosContrato from './DadosContrato';
import DadosCooperativa from './DadosCooperativa';
import Validacao from './Validacao';
import { CONTRATO_TIPO_ASSESSOR_NAME } from '../../../../../library/ContratoTipos';
import { isAuthorizedRequest } from '../../../../../utils/httpResponseHandlers';
import SnackbarUtils from 'utils/SnackbarUtils';

const rootClassName = styles.rootClassName;

class ContratoAssessorEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: props.utils.editing() ? true : false,

      authorizedRequest: true,

      stepIndex: 0,
    };
  }

  componentWillUnmount() {
    this.props.clearContratoAssessorEditing();
  }

  getLoadHtmlContratoMessageError = () => {
    switch (this.props.utils.getVersaoNumberByProps()) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.erroCarregarAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.erroCarregarDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.erroCarregarContrato;
    }
  };

  getLoadMessageError = () => {
    switch (this.props.utils.getVersaoNumberByProps()) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.erroCarregarAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.erroCarregarDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.erroCarregarContrato;
    }
  };

  loadContratoArquivos = () => {
    this.props.loadContratoAssessorArquivos(
      this.props.contratosAssessores.contratoEditing.idContrato,
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadContratoArquivos,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  loadHistoricoAnaliseOperacional = () => {
    let id = null;
    switch (this.props.contratosAssessores.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        id = this.props.contratosAssessores.contratoEditing.idAditivo;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        id = this.props.contratosAssessores.contratoEditing.idDistrato;
        break;
      default:
        id = this.props.contratosAssessores.contratoEditing.idContrato;
        break;
    }
    this.props.loadHistoricoContratoAssessorAnaliseOperacional(
      id,
      this.props.contratosAssessores.contratoEditing.versaoContrato,
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadHistoricoAnaliseOperacional,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  loadContratoAnaliseOperacional = () => {
    let id = null;
    switch (this.props.contratosAssessores.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        id = this.props.contratosAssessores.contratoEditing.idAditivo;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        id = this.props.contratosAssessores.contratoEditing.idDistrato;
        break;
      default:
        id = this.props.contratosAssessores.contratoEditing.idContrato;
        break;
    }
    this.props.loadContratoAnaliseOperacional(
      id,
      this.props.utils.getTipoByProps(),
      this.props.contratosAssessores.contratoEditing.versaoContrato,
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText || this.getLoadHtmlContratoMessageError(),
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  loadMacros = () => {
    this.props.loadMacrosPorTemplate(
      this.props.contratosAssessores.contratoEditing.versaoContrato,
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadingMacrosPorTemplateContratos,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  loadContratoValidacao = () => {
    let id = null;
    switch (this.props.contratosAssessores.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        id = this.props.contratosAssessores.contratoEditing.idAditivo;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        id = this.props.contratosAssessores.contratoEditing.idDistrato;
        break;
      default:
        id = this.props.contratosAssessores.contratoEditing.idContrato;
        break;
    }
    this.props.loadContratoValidacao(
      id,
      this.props.contratosAssessores.contratoEditing.versaoContrato,
      this.props.utils.getTipoNumberByProps(),
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText || this.getLoadHtmlContratoMessageError(),
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  loadContrato = () => {
    let id = null;
    let versao = null;
    switch (this.props.utils.getVersaoByProps()) {
      case CONTRATO_VERSAO_ADITIVO_NAME:
        id = this.props.utils.editing()
          ? this.props.utils.getIdAditivoByProps()
          : this.props.utils.getIdContratoByProps();
        versao = this.props.utils.editing()
          ? CONTRATO_VERSAO_ADITIVO
          : CONTRATO_VERSAO_CONTRATO;
        break;
      case CONTRATO_VERSAO_DISTRATO_NAME:
        id = this.props.utils.editing()
          ? this.props.utils.getIdDistratoByProps()
          : this.props.utils.getIdContratoByProps();
        versao = this.props.utils.editing()
          ? CONTRATO_VERSAO_DISTRATO
          : CONTRATO_VERSAO_CONTRATO;
        break;
      default:
        id = this.props.utils.getIdContratoByProps();
        versao = CONTRATO_VERSAO_CONTRATO;
        break;
    }
    this.setState({ loading: true });
    this.props.loadContratoAssessor(
      id,
      versao,
      () => {
        this.props.changeContratoAssessorEditingValue(
          'versaoContrato',
          this.props.utils.getVersaoNumberByProps()
        );
        if (
          !this.props.utils.editing() &&
          this.props.utils.getIdContratoByProps()
        ) {
          this.props.changeContratoAssessorEditingValue(
            'flgStatus',
            CONTRATO_STATUS_EM_EDICAO
          );
        }
        switch (this.props.utils.getEtapaByProps()) {
          case CONTRATO_EDIT_ETAPA_VALIDACAO:
            this.loadContratoValidacao();
            this.loadHistoricoAnaliseOperacional();
            this.setState({ loading: false });
            break;
          case CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL:
            this.loadContratoAnaliseOperacional();
            this.loadHistoricoAnaliseOperacional();
            this.loadMacros();
            this.setState({ loading: false });
            break;
          case CONTRATO_EDIT_ETAPA_ARQUIVOS:
            this.loadContratoArquivos();
            this.setState({ loading: false });
            break;
          default:
            this.setState({ loading: false });
            break;
        }
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          SnackbarUtils.enqueueSnackbar({
            message: error.response.statusText || this.getLoadMessageError(),
            options: {
              variant: 'error',
            },
          });
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false, authorizedRequest: false });
        }
      }
    );
  };

  refreshStep = () => {
    this.loadContrato();
  };

  componentDidMount() {
    if (this.props.utils.editing()) {
      this.loadContrato();
    } else {
      if (
        this.props.utils.getVersaoNumberByProps() !== CONTRATO_VERSAO_CONTRATO
      ) {
        this.loadContrato();
      }
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.match.url !== this.props.match.url) {
      if (this.props.utils.editing()) {
        this.loadContrato();
      } else {
        if (
          this.props.utils.getVersaoNumberByProps() !== CONTRATO_VERSAO_CONTRATO
        ) {
          this.loadContrato();
        }
      }
    }
  }

  setStepIndex = (index) => {
    this.setState({
      stepIndex: index,
    });
  };

  toEtapaDados = () => {
    if (this.props.utils.editing()) {
      switch (this.props.utils.getVersaoByProps()) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          this.props.history.push(
            contratoAditivoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              this.props.utils.getIdAditivoByProps(),
              CONTRATO_EDIT_ETAPA_DADOS
            )
          );
          break;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          this.props.history.push(
            contratoDistratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              this.props.utils.getIdDistratoByProps(),
              CONTRATO_EDIT_ETAPA_DADOS
            )
          );
          break;
        default:
          this.props.history.push(
            contratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              CONTRATO_EDIT_ETAPA_DADOS
            )
          );
      }
    } else {
      switch (this.props.utils.getVersaoByProps()) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          this.props.history.push(
            contratoAditivoNovoRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              CONTRATO_EDIT_ETAPA_DADOS
            )
          );
          break;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          this.props.history.push(
            contratoDistratoNovoRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              CONTRATO_EDIT_ETAPA_DADOS
            )
          );
          break;
        default:
          return false;
      }
    }
    return true;
  };

  etapaDadosIsEnabled = () => {
    return true;
  };

  etapaDadosColors = () => {
    if (
      this.props.contratosAssessores.contratoEditing.flgStatus ===
      CONTRATO_STATUS_DESATIVADO
    ) {
      return {
        color: styles.disabled,
        contrastColor: '#000',
      };
    }
    return {
      color: this.props.utils.editing()
        ? styles.sicrediGreen
        : styles.pufvYellow,
      contrastColor: this.props.utils.editing()
        ? styles.sicrediGreenContrast
        : styles.pufvYellowContrast,
    };
  };

  toEtapaValidacao = () => {
    if (this.props.utils.editing()) {
      switch (this.props.utils.getVersaoByProps()) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          this.props.history.push(
            contratoAditivoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              this.props.utils.getIdAditivoByProps(),
              CONTRATO_EDIT_ETAPA_VALIDACAO
            )
          );
          break;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          this.props.history.push(
            contratoDistratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              this.props.utils.getIdDistratoByProps(),
              CONTRATO_EDIT_ETAPA_VALIDACAO
            )
          );
          break;
        default:
          this.props.history.push(
            contratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              CONTRATO_EDIT_ETAPA_VALIDACAO
            )
          );
      }
      return true;
    }
    return false;
  };

  etapaValidacaoIsEnabled = () => {
    if (this.props.utils.editing()) {
      return true;
    }
    return false;
  };

  etapaValidacaoColors = () => {
    if (!this.props.utils.editing()) {
      return {
        color: styles.pufvYellow,
        contrastColor: styles.pufvYellowContrast,
      };
    }
    switch (this.props.contratosAssessores.contratoEditing.flgStatus) {
      case CONTRATO_STATUS_EM_EDICAO:
        return {
          color: styles.pufvYellow,
          contrastColor: styles.pufvYellowContrast,
        };
      case CONTRATO_STATUS_EM_ANALISE:
        return {
          color: styles.warning,
          contrastColor: styles.warningContrast,
        };
      case CONTRATO_STATUS_DESATIVADO:
        return {
          color: styles.disabled,
          contrastColor: '#000',
        };
      default:
        return {
          color: styles.sicrediGreen,
          contrastColor: styles.sicrediGreenContrast,
        };
    }
  };

  toEtapaAnaliseOperacional = () => {
    if (this.props.utils.editing()) {
      switch (this.props.utils.getVersaoByProps()) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          this.props.history.push(
            contratoAditivoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              this.props.utils.getIdAditivoByProps(),
              CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL
            )
          );
          break;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          this.props.history.push(
            contratoDistratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              this.props.utils.getIdDistratoByProps(),
              CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL
            )
          );
          break;
        default:
          this.props.history.push(
            contratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL
            )
          );
      }
      return true;
    }
    return false;
  };

  etapaAnaliseOperacionalIsEnabled = () => {
    return (
      this.props.contratosAssessores.contratoEditing.ativo &&
      this.props.utils.editing() &&
      this.props.contratosAssessores.contratoEditing.flgStatus === CONTRATO_STATUS_EM_ANALISE &&
      this.props.auth.userPermissions.contratos.assessor.analiseOperacional.edit
    );
  };

  etapaAnaliseOperacionalColors = () => {
    if (!this.props.utils.editing()) {
      return {
        color: styles.disabled,
        contrastColor: '#000',
      };
    }
    switch (this.props.contratosAssessores.contratoEditing.flgStatus) {
      case CONTRATO_STATUS_EM_ANALISE:
        return {
          color: styles.pufvYellow,
          contrastColor: styles.pufvYellowContrast,
        };
      default:
        return {
          color: styles.disabled,
          contrastColor: '#000',
        };
    }
  };

  toEtapaArquivos = () => {
    if (this.props.utils.editing()) {
      switch (this.props.utils.getVersaoByProps()) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          this.props.history.push(
            contratoAditivoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              this.props.utils.getIdAditivoByProps(),
              CONTRATO_EDIT_ETAPA_ARQUIVOS
            )
          );
          break;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          this.props.history.push(
            contratoDistratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              this.props.utils.getIdDistratoByProps(),
              CONTRATO_EDIT_ETAPA_ARQUIVOS
            )
          );
          break;
        default:
          this.props.history.push(
            contratoEditRoute.getURLWithParams(
              getContratoTipoByRouteParams(this.props.match.params),
              this.props.utils.getIdContratoByProps(),
              CONTRATO_EDIT_ETAPA_ARQUIVOS
            )
          );
      }
    } else {
      const versao = this.props.utils.getVersaoByProps();
      const idContrato = this.props.utils.getIdContratoByProps();
      const urlParams = contratoEditRoute.getURLWithParams(
        getContratoTipoByRouteParams(this.props.match.params),
        idContrato,
        CONTRATO_EDIT_ETAPA_ARQUIVOS
      );
      switch (versao) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
        case CONTRATO_VERSAO_DISTRATO_NAME:
          this.props.history.push(urlParams);
          break;
        default:
          return false;
      }
    }
    return true;
  };

  etapaArquivosIsEnabled = () => {
    if (this.props.utils.editing()) {
      if (
        this.props.utils.getVersaoByProps() === CONTRATO_VERSAO_CONTRATO_NAME
      ) {
        switch (this.props.contratosAssessores.contratoEditing.flgStatus) {
          case CONTRATO_STATUS_AGUARDANDO_ASSINATURA:
          case CONTRATO_STATUS_NAO_INICIADO:
          case CONTRATO_STATUS_VIGENTE:
          case CONTRATO_STATUS_ENCERRADO:
          case CONTRATO_STATUS_DESATIVADO:
            return true;
          default:
            return false;
        }
      }
      return true;
    } else {
      if (
        this.props.utils.getVersaoByProps() === CONTRATO_VERSAO_CONTRATO_NAME
      ) {
        return false;
      }
      return true;
    }
  };

  etapaArquivosColors = () => {
    return {
      color: this.etapaArquivosIsEnabled()
        ? styles.sicrediGreen
        : styles.disabled,
      contrastColor: this.etapaArquivosIsEnabled()
        ? styles.sicrediGreenContrast
        : '#000',
    };
  };

  getSteps = () => {
    let steps = [
      {
        name: this.props.languageValues.contratoNavbarStepNames[
          CONTRATO_TIPO_ASSESSOR_NAME
        ][CONTRATO_EDIT_ETAPA_DADOS],
        ...this.etapaDadosColors(),
        icon: <DescriptionRoundedIcon />,
        onClick: this.toEtapaDados,
        selected:
          this.props.utils.getEtapaByProps() ===
            allContratoAssessorEditEtapas[0]
            ? true
            : false,
        disabled:
          this.props.utils.getEtapaByProps() ===
            allContratoAssessorEditEtapas[0]
            ? true
            : false,
      },
    ];
    steps.push({
      name: this.props.languageValues.contratoNavbarStepNames[
        CONTRATO_TIPO_ASSESSOR_NAME
      ][CONTRATO_EDIT_ETAPA_VALIDACAO],
      ...this.etapaValidacaoColors(),
      icon: <AssignmentTurnedInRoundedIcon />,
      onClick: this.toEtapaValidacao,
      selected:
        this.props.utils.getEtapaByProps() === allContratoAssessorEditEtapas[1]
          ? true
          : false,
      disabled:
        !this.etapaValidacaoIsEnabled() ||
        (this.props.utils.getEtapaByProps() === allContratoAssessorEditEtapas[1]
          ? true
          : false),
    });
    if (this.etapaAnaliseOperacionalIsEnabled()) {
      steps.push({
        name: this.props.languageValues.contratoNavbarStepNames[
          CONTRATO_TIPO_ASSESSOR_NAME
        ][CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL],
        ...this.etapaAnaliseOperacionalColors(),
        icon: <AssignmentLateRoundedIcon id='btnAnaliseOperacional' />,
        onClick: this.toEtapaAnaliseOperacional,
        selected:
          this.props.utils.getEtapaByProps() ===
            allContratoAssessorEditEtapas[2]
            ? true
            : false,
        className: 'btnAnaliseOperacional',
        disabled:
          this.props.utils.getEtapaByProps() ===
            allContratoAssessorEditEtapas[2]
            ? true
            : false,
      });
    }
    steps.push({
      name: this.props.languageValues.contratoNavbarStepNames[
        CONTRATO_TIPO_ASSESSOR_NAME
      ][CONTRATO_EDIT_ETAPA_ARQUIVOS],
      ...this.etapaArquivosColors(),
      icon: <CloudIcon />,
      onClick: this.toEtapaArquivos,
      selected:
        this.props.utils.getEtapaByProps() === allContratoAssessorEditEtapas[3]
          ? true
          : false,
      disabled:
        !this.etapaArquivosIsEnabled() ||
        (this.props.utils.getEtapaByProps() === allContratoAssessorEditEtapas[3]
          ? true
          : false),
    });
    return steps;
  };

  getContentsEtapaDados = () => {
    const editing = this.props.utils.editing();
    const contratoType = this.props.utils.getVersaoByProps();

    let contents = [];
    let totalBullets = 4;

    if (contratoType === CONTRATO_VERSAO_DISTRATO_NAME) {
      totalBullets = 3;
      contents.push(
        {
          component: DadosCooperativa,
          props: {
            totalBullets: totalBullets,
            bulletsIndex: 0,
            editing,
            loading: this.state.loading,
          },
        },
        {
          component: DadosAssessor,
          props: {
            totalBullets: totalBullets,
            bulletsIndex: 1,
            editing,
            loading: this.state.loading,
          },
        },
        {
          component: DadosContrato,
          props: {
            totalBullets: totalBullets,
            bulletsIndex: 2,
            editing,
            loading: this.state.loading,
          },
        }
      );
    } else {
      contents.push(
        {
          component: DadosCooperativa,
          props: {
            totalBullets: totalBullets,
            bulletsIndex: 0,
            editing,
            loading: this.state.loading,
          },
        },
        {
          component: DadosAssessor,
          props: {
            totalBullets: totalBullets,
            bulletsIndex: 1,
            editing,
            loading: this.state.loading,
          },
        },
        {
          component: DadosContrato,
          props: {
            totalBullets: totalBullets,
            bulletsIndex: 3,
            editing,
            loading: this.state.loading,
          },
        }
      );
    }

    return contents;
  };

  getContentsEtapaValidacao = () => {
    const editing = this.props.utils.editing();
    if (!this.etapaValidacaoIsEnabled()) {
      return [];
    }
    return [
      {
        component: Validacao,
        props: {
          utils: this.props.utils,
          editing,
          loading: this.state.loading,
        },
      },
    ];
  };

  getContentsEtapaAnaliseOperacional = () => {
    const editing = this.props.utils.editing();
    if (!this.etapaAnaliseOperacionalIsEnabled()) {
      return [];
    }
    return [
      {
        component: AnaliseOperacional,
        props: {
          etapaValidacaoIsEnabled: this.etapaValidacaoIsEnabled,
          toEtapaValidacao: this.toEtapaValidacao,
          utils: this.props.utils,
          editing,
          loading: this.state.loading,
          refreshStep: this.refreshStep,
        },
      },
    ];
  };

  getContentsEtapaArquivos = () => {
    const editing = this.props.utils.editing();
    if (!this.etapaArquivosIsEnabled()) {
      return [];
    }
    return [
      {
        component: Arquivos,
        props: {
          utils: this.props.utils,
          editing,
          refreshStep: this.refreshStep,
          loading: this.state.loading,
        },
      },
    ];
  };

  getContents = () => {
    switch (this.props.utils.getEtapaByProps()) {
      case CONTRATO_EDIT_ETAPA_DADOS:
        return this.getContentsEtapaDados();
      case CONTRATO_EDIT_ETAPA_VALIDACAO:
        return this.getContentsEtapaValidacao();
      case CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL:
        return this.getContentsEtapaAnaliseOperacional();
      case CONTRATO_EDIT_ETAPA_ARQUIVOS:
      default:
        return this.getContentsEtapaArquivos();
    }
  };

  hasPermissions = () => {
    const editing = this.props.utils.editing();
    if (this.state.loading) {
      return true;
    }
    if (editing) {
      if (
        this.props.auth.userPermissions.contratos.assessor.view ||
        this.props.auth.userPermissions.contratos.assessor.edit ||
        this.props.auth.userPermissions.contratos.assessor.analiseOperacional
          .edit
      ) {
        if (
          this.state.loading === false &&
          this.props.contratosAssessores.contratoEditing.idContrato &&
          this.props.auth.userPermissions.contratos.assessor.allStatus.indexOf(
            this.props.contratosAssessores.contratoEditing.flgStatus
          ) > -1
        ) {
          return true;
        }
      }
    } else {
      if (this.props.auth.userPermissions.contratos.assessor.register) {
        return true;
      }
    }
    return false;
  };

  routeParamsIsValid = () => {
    const versao = this.props.utils.getVersaoByProps();
    const etapa = this.props.utils.getEtapaByProps();
    const editing = this.props.utils.editing();
    if (editing) {
      switch (versao) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          return this.props.utils.getIdContratoByProps() &&
            this.props.utils.getIdAditivoByProps() &&
            etapa
            ? true
            : false;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          return this.props.utils.getIdContratoByProps() &&
            this.props.utils.getIdDistratoByProps() &&
            etapa
            ? true
            : false;
        default:
          return this.props.utils.getIdContratoByProps() && etapa
            ? true
            : false;
      }
    } else {
      switch (versao) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
        case CONTRATO_VERSAO_DISTRATO_NAME:
          return this.props.utils.getIdContratoByProps() && etapa
            ? true
            : false;
        default:
          return etapa ? true : false;
      }
    }
  };

  render() {
    const steps = this.getSteps();
    const contents = this.getContents();
    return this.hasPermissions() &&
      this.routeParamsIsValid() &&
      this.state.authorizedRequest &&
      contents.length > 0 ? (
      <CrudWithSteps
        className={rootClassName}
        steps={steps}
        contents={contents}
        contentIndex={this.state.stepIndex}
        setContentIndex={this.setStepIndex}
      />
    ) : this.state.loading ? null : (
      <UnauthorizedScreen />
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoAssessorEditingValue,
      loadContratoAssessor,
      loadContratoValidacao,
      loadHistoricoContratoAssessorAnaliseOperacional,
      loadContratoAnaliseOperacional,
      loadMacrosPorTemplate,
      loadContratoAssessorArquivos,
      clearContratoAssessorEditing,
      loadEmpresaByCnpj,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ContratoAssessorEdit));
